import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from "../components/header/header.component";
import { FooterComponent } from "../components/footer/footer.component";
import { NavbarComponent } from "../components/navbar/navbar.component";
import { SideMenuComponent } from "../components/side-menu/side-menu.component";
import { SearchComponent } from '../components/search/search.component';
import { SharedModule } from "./shared.module";
import {CategoryDropdownComponent} from "../components/category-dropdown/category-dropdown.component";
import {TemplateOneComponent} from "../components/landing-templates/template-one/template-one.component";
import {
  PromotionVerticalComponent
} from "../components/landing-templates/promotion-vertical/promotion-vertical.component";
import {PromotionBannerComponent} from "../components/landing-templates/promotion-banner/promotion-banner.component";
import {FeatureProductsComponent} from "../components/landing-templates/feature-products/feature-products.component";


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    NavbarComponent,
    SideMenuComponent,
    SearchComponent,
    CategoryDropdownComponent,
    TemplateOneComponent,
    PromotionVerticalComponent,
    PromotionBannerComponent,
    FeatureProductsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,


  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    NavbarComponent,
    SideMenuComponent,
    SearchComponent,
    SharedModule,
    CategoryDropdownComponent,
    TemplateOneComponent,
  ]
})
export class LayoutModule { }
